const FeedbackData = [
    {
      id: 1,
      rating: 10,
      text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. consequuntur vel vitae commodi alias voluptatem est voluptatum ipsa quae.',
    },
    {
      id: 2,
      rating: 9,
      text: 'Consequuntur vel vitae commodi alias voluptatem est voluptatum ipsa quae.',
    },
    {
      id: 3,
      rating: 8,
      text: 'Ipsum dolor sit amet consectetur adipisicing elit. consequuntur vel vitae commodi alias voluptatem est voluptatum ipsa quae.',
    },
    {
      id: 4,
      rating: 6,
      text: 'Dolor sit amet consectetur adipisicing alias voluptatem est voluptatum ipsa quae.',
    },
    {
      id: 5,
      rating: 7,
      text: 'Vel vitae commodi alias voluptatem est voluptatum ipsa quae.',
    },
  ]
  
  export default FeedbackData